import type { CustomerFormValues } from '@/api/types';
import { MySection } from '@/components/custom/my-section';
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  TextField,
} from '@mui/material';
import { Controller, type Control, type FieldErrors } from 'react-hook-form';

const saleChannelOptions = [
  'Facebook',
  'Instagram',
  'Line',
  'Website',
  'Walk-in',
  'Other',
] as const;

interface CustomerPreferencesSectionProps {
  control: Control<CustomerFormValues>;
  errors: FieldErrors<CustomerFormValues>;
}

export function CustomerPreferencesSection({ control, errors }: CustomerPreferencesSectionProps) {
  return (
    <MySection title="Preferences" description="Capture shipping and sales preferences.">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="saleChannel"
            render={({ field }) => (
              <TextField
                select
                fullWidth
                label="Sale channel"
                InputLabelProps={{ shrink: true }}
                value={field.value}
                onChange={field.onChange}
                error={!!errors.saleChannel}
                helperText={errors.saleChannel?.message}
              >
                {saleChannelOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="notTransfer"
            render={({ field }) => (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={field.value}
                      onChange={(event) => field.onChange(event.target.checked)}
                      sx={{
                        color: '#2563EB', // blue-600 when unchecked (border)
                        '&.Mui-checked': {
                          color: '#2563EB', // blue-600
                        },
                        '&.MuiCheckbox-root:hover': {
                          backgroundColor: 'rgba(37, 99, 235, 0.1)', // subtle hover tint
                        },
                      }}
                    />
                  }
                  label="Not transfer"
                />
                <FormHelperText>
                  Mark when the customer does not need to transfer payment.
                </FormHelperText>
              </>
            )}
          />
        </Grid>
      </Grid>
    </MySection>
  );
}

export default CustomerPreferencesSection;
